import { createContext } from 'react';
import type { AppConfig, ZoneConfig } from './types';
import type { Zone } from '@seek/audience-zones';
import { getBrandFromZone } from './utils/getBrandFromZone';
import type { CountrySiteName, Locale } from '@seek/melways-sites';

interface GenerateConfigArgs {
  zone: Zone;
  site: CountrySiteName;
  requestedLocale: Locale;
}

export const AppConfigContext = createContext<AppConfig>({} as AppConfig);

export const generateConfig = ({
  zone,
  requestedLocale,
  site,
}: GenerateConfigArgs): AppConfig => {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const config = require(`./zone-configs/${zone}`).default as ZoneConfig;

  return {
    ...config,
    brand: getBrandFromZone(zone),
    selectedLocale: determineSelectedLocale({ config, requestedLocale }),
    site,
  };
};

const determineSelectedLocale = ({
  config,
  requestedLocale,
}: {
  config: ZoneConfig;
  requestedLocale: Locale;
}) => {
  const available = config.availableLocales.includes(requestedLocale);
  return available ? requestedLocale : config.defaultLocale;
};
